export default "__VITE_ASSET__CnldnGD1__"